import "./index.scss";
import { BannerAdvProps } from "./types";
import React from "react";

const BannerAdv = ({ children, text }: BannerAdvProps) => {
  return (
    <div className="BannerAdv">
      <div data-testid="bannerContent" className="BannerAdv__content">
        {children}
      </div>
      <div className="BannerAdv__text">{text}</div>
    </div>
  );
};

export default BannerAdv;
